import type { TimesheetStatus } from '../Timesheets/config';

// Re-export types from Timesheets module for consistency
export type { TimesheetBatch, TimesheetEntry } from '../Timesheets/config';

export { TIMESHEET_STATUS_OPTIONS } from '../Timesheets/config';

// Additional types specific to AllTimesheets
export interface Employee {
  /** team_members.id, a uuid. */
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  is_active: boolean;
  type: string;
  role: string;
}

/**
 * What the sidebar shows next to each employee: the state of their week for
 * the selected week ending, and how many past weeks are still in Draft.
 */
export interface EmployeeWeekStatus {
  status: TimesheetStatus | null;
  overdueCount: number;
}

export interface EmployeeFilterConfig {
  searchText: string;
  isActive: boolean | null;
  type: string | null;
}

// Utility functions
export const formatEmployeeName = (employee: Employee): string => {
  return `${employee.first_name} ${employee.last_name}`;
};

export const filterEmployees = (employees: Employee[], filters: EmployeeFilterConfig): Employee[] => {
  return employees.filter(employee => {
    // Search text filter
    if (filters.searchText) {
      const searchLower = filters.searchText.toLowerCase();
      const fullName = formatEmployeeName(employee).toLowerCase();
      const emailMatch = employee.email.toLowerCase().includes(searchLower);
      const nameMatch = fullName.includes(searchLower);
      
      if (!nameMatch && !emailMatch) {
        return false;
      }
    }

    // Active status filter
    if (filters.isActive !== null && employee.is_active !== filters.isActive) {
      return false;
    }

    // Type filter
    if (filters.type && employee.type !== filters.type) {
      return false;
    }

    return true;
  });
};

export const INITIAL_EMPLOYEE_FILTER: EmployeeFilterConfig = {
  searchText: '',
  isActive: true, // Default to showing only active employees
  type: null
}; 